import {CardText, CardActions} from "material-ui/Card"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {containers} from "@swarm2/core"
import Button from "material-ui/RaisedButton"
import React from "react"
import TextField from "material-ui/TextField"
import SubmitIcon from "material-ui/svg-icons/action/help-outline"

import * as Util from "../common"
import _Error from "./Error"

const M = Util.intlMessages("view.ResetPasswordView")
const EM = Util.intlMessages("view.ResetPasswordView.error")
const Error = _Error(EM)

function ResetPasswordRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {input, formErrors} = props
  return (
    <div>
      <form
        onSubmit={
          props.isSubmitAllowed ? props.submit : e => e.preventDefault()
        }
      >
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle text={<M id="title" />} />
          </ToolbarGroup>
        </Toolbar>
        <CardText>
          <p>
            <M id="description" />
          </p>
          <div>
            <TextField
              name="email"
              floatingLabelText={<M id="field.email" />}
              value={props.email}
              onChange={input.setEmail}
            />
          </div>
          <div>
            <TextField
              name="errors"
              underlineShow={false}
              disabled={true}
              errorText={formErrors.map((error, i) => (
                <Error key={i} error={error} />
              ))}
            />
          </div>
        </CardText>
        <CardActions>
          <Button
            primary
            label={<M id="submit" />}
            type="submit"
            icon={<SubmitIcon />}
            disabled={!props.isSubmitAllowed}
            onClick={props.submit}
          />
        </CardActions>
        <CardText>
          {props.request.state === "SUCCESS" ? <M id="success" /> : null}
        </CardText>
      </form>
    </div>
  )
}
export default containers.authSignin.ResetPassword()(
  Util.DumpProps(ResetPasswordRender),
)



// WEBPACK FOOTER //
// ./src/auth-signin/ResetPasswordView.js